import React, { forwardRef, memo } from 'react';
import Highcharts from 'highcharts';
import BreakAxis from 'highcharts/modules/broken-axis';
import HighchartsReact from 'highcharts-react-official';
import PropTypes from 'prop-types';

import { chartStyle } from '../config';

BreakAxis(Highcharts);

const LineChart = forwardRef((props, ref) => {
  const { options } = props;

  return (
    <div className="eps-highchart-wrapper">
      <HighchartsReact
        ref={ref}
        highcharts={Highcharts}
        constructorType="chart"
        // immutable={true}
        options={options}
        containerProps={{
          style: chartStyle,
        }}
      />
    </div>
  );
});
LineChart.propTypes = {
  options: PropTypes.object,
};

export default memo(LineChart);
